export const PAYMENT_METHOD_BANK_TRANSFER = 'bank_transfer';
export const PAYMENT_METHOD_PAYU = 'payu';
export const PAYMENT_METHOD_TRANSFER = 'TRANSFER';

export const hasTransferDetails = (config) =>
  !!(config?.accountNumber || config?.iban || config?.recipientName);

export const isUnpaidBankTransferPayment = (payment) =>
  !payment?.paidDate && payment?.paymentMethod === PAYMENT_METHOD_TRANSFER;

export const unpaidBankTransferPayments = (payments) =>
  sortPaymentsByDueDate((payments ?? []).filter(isUnpaidBankTransferPayment));

export const shouldShowBankTransferNextSteps = (order, payments, bankTransferConfig) =>
  order?.status === 'PENDING_PAYMENT'
  && unpaidBankTransferPayments(payments).length > 0
  && hasTransferDetails(bankTransferConfig);

export const formatReservationStatus = (status) => {
  switch (status) {
    case 'CONFIRMED':
      return 'Potwierdzona';
    case 'PENDING_PAYMENT':
      return 'Oczekuje na płatność';
    case 'DRAFT':
      return 'Wersja robocza';
    case 'CANCELLED':
      return 'Anulowana';
    default:
      return status ?? '—';
  }
};

export const buildThankYouMessage = (status, propertyName) => {
  const name = propertyName?.trim();
  const base = name ? `Dziękujemy za rezerwację w ${name}.` : 'Dziękujemy za rezerwację.';
  if (status === 'CONFIRMED') {
    return `${base} Twoja rezerwacja została potwierdzona.`;
  }
  return base;
};

export const PAYMENT_ERROR_MESSAGES = {
  PAYMENT_FAILED:
    'Płatność przez PayU nie powiodła się lub została anulowana. Możesz spróbować ponownie lub wybrać przelew bankowy.',
};

export const CHECKOUT_ERROR_MESSAGES = {
  payment_failed: PAYMENT_ERROR_MESSAGES.PAYMENT_FAILED,
};

export const GENERIC_CHECKOUT_PAYMENT_ERROR =
  'Płatność nie powiodła się. Spróbuj ponownie lub wybierz inną metodę płatności.';

export const getCheckoutErrorMessage = (errorCode) => {
  if (!errorCode) return null;
  return CHECKOUT_ERROR_MESSAGES[errorCode] ?? GENERIC_CHECKOUT_PAYMENT_ERROR;
};

export const formatNightsLabel = (nights) => {
  if (nights === 1) return '1 noc';
  if (nights >= 2 && nights <= 4) return `${nights} noce`;
  return `${nights} nocy`;
};

export const formatDate = (d) => {
  if (!d) return '—';
  const date = d instanceof Date ? d : new Date(d);
  return date.toLocaleDateString('pl-PL', { day: 'numeric', month: 'long', year: 'numeric' });
};

export const formatPrice = (value) =>
  value != null ? `${Number(value).toFixed(2)} PLN` : '—';

export const sortPaymentsByDueDate = (payments) =>
  [...payments].sort((a, b) => {
    const da = a.dueDate ? new Date(a.dueDate).getTime() : 0;
    const db = b.dueDate ? new Date(b.dueDate).getTime() : 0;
    return da - db;
  });

export const paymentMethodLabel = (method) => {
  if (!method) return '—';
  if (method === 'PAYU') return 'PayU';
  if (method === 'TRANSFER') return 'Przelew bankowy';
  return method;
};

export const applyOptimisticPayuPayments = (payments, optimisticPaidIds) =>
  (payments || []).map((p) =>
    optimisticPaidIds.includes(String(p.id)) && !p.paidDate
      ? { ...p, paidDate: new Date(), paymentMethod: 'PAYU', _optimistic: true }
      : p
  );

export const parsePayuPaymentIds = (paymentIdParam) =>
  paymentIdParam
    ? paymentIdParam.split('-').map((id) => id.trim()).filter(Boolean)
    : [];
